export default Object.freeze({
  Danger: 'danger',
  Success: 'success',
  Warning: 'warning',
});
